(function () {
  var DESKTOP_QUERY = '(min-width: 768px)';

  function createNavButton(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mcr-blog__scroll-nav mcr-blog__scroll-nav--' + direction;
    btn.setAttribute(
      'aria-label',
      direction === 'next' ? 'Show next articles' : 'Show previous articles'
    );
    btn.innerHTML =
      direction === 'next'
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return btn;
  }

  function positionNavButtons(wrapper, row) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      wrapper.style.removeProperty('--mcr-scroll-nav-top');
      return;
    }

    var image = row.querySelector('.mcr-blog__card-image');
    if (!image) return;

    wrapper.style.setProperty(
      '--mcr-scroll-nav-top',
      image.offsetHeight / 2 + 'px'
    );
  }

  function updateNavButtons(row, prevBtn, nextBtn) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      return;
    }

    var maxScroll = row.scrollWidth - row.clientWidth;
    prevBtn.hidden = row.scrollLeft <= 1;
    nextBtn.hidden = maxScroll <= 1 || row.scrollLeft >= maxScroll - 1;
  }

  function initScrollRow(row) {
    if (row.dataset.carouselInit === 'true') return;
    row.dataset.carouselInit = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'mcr-blog__scroll-carousel';
    row.parentNode.insertBefore(wrapper, row);
    wrapper.appendChild(row);

    var prevBtn = createNavButton('prev');
    var nextBtn = createNavButton('next');
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    function scrollBy(direction) {
      var card = row.querySelector('.mcr-blog__card');
      if (!card) return;

      var gap = parseFloat(getComputedStyle(row).gap) || 14;
      row.scrollBy({
        left: direction * (card.offsetWidth + gap),
        behavior: 'smooth',
      });
    }

    prevBtn.addEventListener('click', function () {
      scrollBy(-1);
    });
    nextBtn.addEventListener('click', function () {
      scrollBy(1);
    });

    row.addEventListener(
      'scroll',
      function () {
        updateNavButtons(row, prevBtn, nextBtn);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      positionNavButtons(wrapper, row);
      updateNavButtons(row, prevBtn, nextBtn);
    });

    positionNavButtons(wrapper, row);
    updateNavButtons(row, prevBtn, nextBtn);

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        positionNavButtons(wrapper, row);
      });
      resizeObserver.observe(row);
    }
  }

  function initAll() {
    document.querySelectorAll('.mcr-blog__scroll-row').forEach(initScrollRow);
  }

  function setup() {
    initAll();

    var blogRoot = document.getElementById('mcr-blog');
    if (blogRoot && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        initAll();
      });
      observer.observe(blogRoot, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
